<template>
  <div>
    <div class="container px-0 mx-0">
      <div class="card h-100">
        <div class="card-body">
          <div class="account-settings">
            <div class="user-profile">
              <div class="user-avatar">
                <img src="https://bootdey.com/img/Content/avatar/avatar7.png" alt="Maxwell Admin" />
              </div>
              <h5 class="user-name">{{user.fname}} {{user.lname}}</h5>
              <h6 v-if="formData.role == 0" class="user-email">Super Admin</h6>
              <h6 v-else-if="formData.role == 1" class=" user-email">Admin</h6>
              <h6 v-else-if="formData.role == 2" class=" user-email">CRM</h6>
              <h6 v-else-if="formData.role == 3" class=" user-email">Editor</h6>
              <h6 v-else-if="formData.role == 4" class=" user-email">Support</h6>
            </div>
          </div>
          <div class="row gutters">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <p class="mt-3 mb-2 color-default">
                <b>Profile Picture</b>
              </p>
            </div>
            <form>
              <div class="form-inline text-right">
                <input type="file" accept="image/*" @change="onChange" />
                <div id="preview">
                  <img v-if="item.imageUrl" :src="item.imageUrl" />
                </div>
              </div>
            </form>
          </div>

          <form>
            <div class="row gutters mt-5">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <p class="mb-2 color-default"><b>Personal Details</b><span style="color: red">*</span>:</p>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="form-group">
                  <label for="fullName"><b>First Name</b><span style="color: red">*</span>:</label>
                  <input type="text" class="form-control" required v-model="user.fname" />
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="form-group">
                  <label for="eMail"><b>Last Name</b><span style="color: red">*</span>:</label>
                  <input type="text" class="form-control" required v-model="user.lname" />
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="Phone"><b>Username</b><span style="color: red">*</span>:</label>
              <input type="text" class="form-control" required v-model="user.user_name" value="" />
            </div>

            <div class="form-group">
              <label for="Age"><b>Email</b><span style="color: red">*</span>:</label>
              <input type="email" class="form-control" required v-model="user.email" value="" />
            </div>

            <div class="row gutters">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="text-right">
                  <button type="button" class="btn btn-success btn-sm ml-1" @click="save">
                    Update
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        item: {
          image: null,
          imageUrl: null
        },
        user:{
          fname:'',
          lname:'',
          email:'',
          user_name:''
        }
      }

    },
    props: [
      'action', 'formData'
    ],
    mounted:function() {
      const permission = {
      headers: {
        'X-Permission': 'admin_users_list' 
      }
    };

       axios.get('/admin/users/get-all-users?id=' + this.formData.id,permission)
          .then((response) => {
            let res = response.data.data;
            this.user.fname = res.first_name;
            this.user.lname = res.last_name;
            this.user.email = res.email;
            this.user.user_name = res.user_name;
          });
    },
    methods: {
      save() {
        let user_id = this.formData.id;
        let user_name = this.user.user_name;
        let usr_first_name = this.user.fname;
        let usr_last_name = this.user.lname;
        let usr_email = this.user.email;
        let usr_type = this.formData.role;
        if (
          user_name.replace(/\s/g, "").length &&
          usr_first_name.replace(/\s/g, "").length &&
          usr_last_name.replace(/\s/g, "").length &&
          usr_email.replace(/\s/g, "").length &&
          usr_type.replace(/\s/g, "").length
        ) {
          axios.post("admin/users/update-admin-user", {
            id: user_id, user_name: user_name, first_name: usr_first_name, last_name: usr_last_name, email: usr_email, role_id: usr_type,
          }).then(() => {
            window.$("#modal").modal("hide");
            localStorage.setItem('f_name', usr_first_name);
            localStorage.setItem('l_name', usr_last_name);
            this.$toast.success('Profile Updated Successfully!');
          })
            .catch((error) => {
              let response = error.response.message;
              this.$toast.error(response, {
                position: "top-center",
              });
            });
        } else {
          this.$toast.warning('Please Fill All Required Fields');
        }
      },
      onChange(e) {
        const file = e.target.files[0]
        this.image = file
        this.item.imageUrl = URL.createObjectURL(file);
      },
    }

  }
</script>

<style>

</style>
<style scoped>
  .account-settings .user-profile {
    margin: 0 0 1rem 0;
    padding-bottom: 1rem;
    text-align: center;
  }

  .account-settings .user-profile .user-avatar {
    margin: 0 0 1rem 0;
  }

  .account-settings .user-profile .user-avatar img {
    width: 90px;
    height: 90px;
    -webkit-border-radius: 100px;
    -moz-border-radius: 100px;
    border-radius: 100px;
  }

  .account-settings .user-profile h5.user-name {
    margin: 0 0 0.5rem 0;
  }

  .account-settings .user-profile h6.user-email {
    margin: 0;
    font-size: 0.8rem;
    font-weight: 400;
    color: #9fa8b9;
  }

  .form-control {
    border: 1px solid #cfd1d8;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
    font-size: 0.825rem;
    background: #ffffff;
    color: #2e323c;
  }

  .card {
    background: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    border: 0;
    margin-bottom: 1rem;
  }
</style>